import React from 'react';
import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
import Section3 from './section3';
import Section4 from './section4';
import './index.less';
import './index.en.less';

interface ITopicFrameworksProps {
  settings: any;
}

const TopicFrameworks: React.FunctionComponent<ITopicFrameworksProps> = ({
  settings,
}) => (
  <TopicContainer className="frameworks">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item frameworks_2" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item frameworks_3" id="3">
      <Section2 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item frameworks_4" id="4">
      <Section3 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item frameworks_5" id="5">
      <Section4 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default TopicFrameworks;
